<style lang="less" scoped>
@import '@/style/index.less';
.collection-list{
  width: 100%;
  .collection-list-title{
    display: flex;
    justify-content: space-between;
  }
}
</style>

<template>
  <div class="collection-list" >
    <div class="collection-list-title">
      <DetailTitle title="催收记录" :collapse="collapse" @collapse="onCollapseChange" />
      <div v-if="!collapse" v-show="!unOperate">
        <a-button type="primary" @click="onBuild">新增</a-button>
        <a-button style="margin-left: 16px;" type="default" @click="startPaymentProcess">发起回款流程</a-button>
      </div>
    </div>
    <div v-if="!collapse" v-show="!collapse">
      <a-radio-group v-model:value="menu.current" :disabled="operate" @change="loadData" style="margin-bottom: 16px" >
        <a-radio-button v-for="(val, index) in menu.list" :key="index" :value="val.value">{{val.label}}</a-radio-button>
      </a-radio-group>
    </div>
    <ListView v-if="!collapse" ref="list-view" :complex-list="mainData" :option="listOption" @menu="onMenu" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ComplexList, DefaultEdit, SelectList } from 'complex-data'
import { unformatOption } from 'complex-data/src/lib/DictionaryData'
import ListView from '@/components/data/ListView'
import config from '@/config'
import { reactiveLayout } from '@/plugin'
import { listWidth } from '@/config/dictionary/config'
import { buildDictionaryBySelect } from '@/config/dictionary'
import user from '@/data/user'
import DetailTitle from '../DetailTitle.vue'
import overdueApi from '../../api/overdue'
import { dict } from '../../select/dict'
import { baseSwitch } from '../../select'
import { location, locationSelectValueType } from '@/pages/index/select/location'
import { overdueCollectType } from '../../select/overdue'
import { getFile, uploadFile } from '../../utils/file'
import old from '../../data/old'

export class CollectionList extends ComplexList {
  $getDictionaryPageList(modName: string, option?: unformatOption | undefined) {
    const list = super.$getDictionaryPageList(modName, option)
    if (modName === 'list') {
      const recordType = this.$getExtra('overdueCollectType')
      if (recordType === '1') {
        // 电催
        return list.filter(item => item.prop !== 'actualVisitTime')
      }
    }
    return list
  }
  getInfo(record: Record<string, any>) {
    return new Promise((resolve, reject) => {
      if (record.recordType.value === '2') {
        getFile(record.id).then(res => {
          record.fileList = res.file
          resolve({ status: 'success' })
        }).catch(err => {
          reject(err)
        })
      } else {
        resolve({ status: 'success' })
      }
    })
  }
  buildItem(postData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      postData.overdueRecordId = this.$getExtra('parent').id
      postData.collectionPersonName = user.info.name
      overdueApi.overdueCollectionBuild.require(postData).then(() => {
        this.$reloadData({
          force: true
        })!.finally(() => {
          resolve({ status: 'success' })
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
}

export default defineComponent({
  name: 'CollectionList',
  components: {
    DetailTitle,
    ListView
  },
  props: {
    detail: {
      type: Object,
      required: false
    },
    unOperate: {
      type: Boolean,
      required: false
    },
    defaultCollapse: {
      type: Boolean,
      required: false
    }
  },
  data() {
    const overdueCollectTypeList = overdueCollectType.getList()
    const contractNumber = new SelectList({
      list: []
    })
    const mainData = new CollectionList({
      name: '催收记录',
      prop: 'collectionList',
      module: {
        pagination: {},
        dictionary: {
          layout: {
            default: {
              grid: 12,
              label: 8,
              content: 16
            }
          },
          option: {},
          propData: {
            id: 'id'
          },
          list: [
            {
              prop: 'id',
              name: 'ID',
              originProp: 'id',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'overdueRecordId',
              name: '逾期记录ID',
              originProp: 'overdueRecordId',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'contractNumber',
              name: '合同号',
              originProp: 'contractNumber',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.contractNumber
                }
              }
            },
            {
              prop: 'customerName',
              name: '承租人',
              originProp: 'customerName',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.getWidth(6)
                }
              }
            },
            buildDictionaryBySelect(overdueCollectType, {
              prop: 'recordType',
              name: '类型',
              originProp: 'recordType',
              originFrom: 'list',
              mod: {
                edit: {
                  required: true,
                  observe(target, prop, val) {
                    if (prop === 'recordType') {
                      if (val === '2') {
                        target.show('provincecode')
                        target.show('address')
                        target.show('actualVisitTime')
                        target.show('fileList')
                      } else {
                        target.hidden('provincecode')
                        target.hidden('address')
                        target.hidden('actualVisitTime')
                        target.hidden('fileList')
                      }
                    }
                  },
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }),
            {
              prop: 'collectionPersonId',
              name: '催收人员ID',
              originProp: 'collectionPersonId',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'collectionPersonName',
              name: '催收人员',
              originProp: 'collectionPersonName',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.getWidth(6)
                }
              }
            },
            buildDictionaryBySelect(dict.CollectionRecordRiskType, {
              prop: 'riskType',
              name: '风险类型',
              originProp: 'riskType',
              originFrom: 'list',
              mod: {
                edit: {
                  required: true,
                  multiple: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }, {
              multiple: 'string'
            }),
            buildDictionaryBySelect(dict.CollectionRecordOverReason, {
              prop: 'overReason',
              name: '逾期类型',
              originProp: 'overReason',
              originFrom: 'list',
              mod: {
                edit: {
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(dict.CollectionRecordCollectionResult, {
              prop: 'collectionResult',
              name: '催收结果',
              originProp: 'collectionResult',
              originFrom: 'list',
              mod: {
                list: {},
                edit: {
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(contractNumber, {
              prop: 'contactPhone',
              name: '联系电话',
              originProp: 'contactPhone',
              originFrom: 'list',
              mod: {
                edit: {
                  required: true,
                  $getData(this: DefaultEdit<'select'>) {
                    this.$option.list = contractNumber.getList()
                    return Promise.resolve({ status: 'success' })
                  }
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(baseSwitch, {
              prop: 'proceedingFlag',
              name: '是否法诉',
              originProp: 'proceedingFlag',
              originFrom: 'list',
              mod: {
                edit: {
                  required: true,
                  value: {
                    default: '0'
                  }
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            }),
            {
              prop: 'provincecode',
              showProp: {
                default: 'value',
                list: 'label'
              },
              name: '省市',
              originProp: 'provincecode',
              originFrom: 'list',
              layout: {
                default: {
                  grid: 24,
                  label: 4,
                  content: 20
                }
              },
              format(value, { originData }) {
                const cityCode = originData!.citycode
                const provinceValue = location.getItem(value) as locationSelectValueType
                const valueList = [value, cityCode]
                if (cityCode && provinceValue.children) {
                  const cityValue = provinceValue.children.find(item => item.value === cityCode)
                  return {
                    value: valueList,
                    label: cityValue!.label
                  }
                }
                return {
                  value: valueList,
                  label: provinceValue.label
                }
              },
              post(value, { targetData }) {
                const [provinceCode, cityCode] = value as [string, string]
                targetData.citycode = cityCode
                return provinceCode
              },
              mod: {
                edit: {
                  type: 'cascader',
                  required: true,
                  option: {
                    list: location.getList()
                  }
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'address',
              name: '详细地址',
              originProp: 'address',
              originFrom: 'list',
              layout: {
                default: {
                  grid: 24,
                  label: 4,
                  content: 20
                }
              },
              mod: {
                edit: {
                  type: 'input',
                  required: true,
                  option: {
                    maxLength: 100
                  }
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'actualVisitTime',
              name: '实际上门时间',
              originProp: 'actualVisitTime',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.getWidth(6)
                },
                edit: {
                  type: 'date',
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'overReasonRemark',
              name: '逾期原因',
              originProp: 'overReasonRemark',
              originFrom: 'list',
              layout: {
                default: {
                  grid: 24,
                  label: 4,
                  content: 20
                }
              },
              mod: {
                edit: {
                  type: 'textArea',
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'remark',
              name: '内容',
              originProp: 'remark',
              originFrom: 'list',
              layout: {
                default: {
                  grid: 24,
                  label: 4,
                  content: 20
                }
              },
              mod: {
                list: {
                  width: 320
                },
                edit: {
                  type: 'textArea',
                  required: true
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'fileList',
              name: '附件',
              originProp: 'fileList',
              originFrom: 'list',
              layout: {
                default: {
                  grid: 24,
                  label: 4,
                  content: 20
                }
              },
              post(value) {
                return value ? (value as any[]).map(item => item.data) : null
              },
              mod: {
                edit: {
                  type: 'file',
                  multiple: true,
                  required: false,
                  local: {
                    target: {
                      props: {
                        complex: true
                      }
                    }
                  },
                  value: {
                    default: () => {
                      return []
                    }
                  },
                  option: {
                    accept: config.file,
                    upload (fileList) {
                      return uploadFile(fileList as unknown as File[], 'overdueCollection')
                    }
                  }
                },
                build: {
                  $target: 'edit'
                },
                detail: {
                  $target: 'edit'
                }
              }
            },
            {
              prop: 'createdBy',
              name: '创建人id',
              originProp: 'createdBy',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'createdTime',
              name: '创建时间',
              originProp: 'createdTime',
              originFrom: 'list',
              mod: {
                list: {
                  width: listWidth.time
                }
              }
            },
            {
              prop: 'updatedBy',
              name: '更新人',
              originProp: 'updatedBy',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'updatedTime',
              name: '更新时间',
              originProp: 'updatedTime',
              originFrom: 'list',
              mod: {}
            },
            {
              prop: 'menu',
              name: '操作',
              originProp: 'menu',
              originFrom: 'local',
              mod: {
                list: {
                  width: listWidth.getWidth(4, 1)
                }
              }
            },
          ]
        }
      },
      $getData(this: CollectionList) {
        return new Promise((resolve, reject) => {
          overdueApi.overdueCollectionList.require({
            contractNumber: this.$getExtra('parent').contractNumber,
            recordType: this.$getExtra('overdueCollectType'),
            pageNo: this.$getPageData('current')!,
            pageSize: this.$getPageData('size')!
          }).then(res => {
            this.$formatList(res.data.data, res.data.totalCount)
            resolve({ status: 'success' })
          }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err)
            reject(err)
          })
        })
      }
    })
    return {
      collapse: this.defaultCollapse,
      contractNumber: contractNumber,
      mainData: mainData,
      menu: {
        current: overdueCollectTypeList[0].value,
        list: overdueCollectTypeList
      },
      listOption: {
        table: {
          optionProps: {
            bordered: true,
            scroll: {
              x: this.getWidth()
            }
          }
        },
        search: false,
        menu: {
          list: [
            {
              prop: 'quote',
              name: '引用'
            },
            {
              prop: 'detail',
              name: '详情'
            }
          ]
        },
        info: {
          modal: {
            optionProps: {
              width: 960
            }
          }
        },
        edit: {
          modal: {
            optionProps: {
              width: 960
            }
          }
        }
      }
    }
  },
  computed: {
    width() {
      return this.getWidth()
    },
    operate() {
      return this.mainData.$getStatus('operate') === 'ing'
    }
  },
  watch: {
    detail: {
      immediate: true,
      handler(val) {
        if (val) {
          this.mainData.$setExtra('parent', val)
          this.loadPage()
        }
      }
    },
  },
  beforeUnmount() {
    this.mainData.$reset()
  },
  methods: {
    getWidth() {
      return reactiveLayout.data.main.width - 16 * 2
    },
    loadPage() {
      this.loadContract().finally(() => {
        this.loadData()
      })
    },
    loadContract() {
      return new Promise((resolve, reject) => {
        overdueApi.overdueAllContactsList.require({
          overdueRecordId: this.detail?.id
        }).then(res => {
          const list = res.data.data.map((item: any) => {
            return {
              value: item.contactPhone,
              label: item.contactTypeName + '/' + item.contactName + '/' + item.contactPhone
            }
          })
          this.contractNumber.setList(list)
          resolve({ status: 'success' })
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
          reject(err)
        })
      })
    },
    onMenu(from: string, act: string, payload?: any) {
      if (from === 'table' && act === 'quote') {
        const record = {
          ...payload.record
        }
        delete record.contactPhone
        delete record.remark;
        (this.$refs as any)['list-view'].openEdit('build', '新增', record)
      }
    },
    loadData() {
      this.mainData.$setExtra('overdueCollectType', this.menu.current)
      this.mainData.$reloadData(true)
    },
    onBuild() {
      const maxDay = this.detail?.maxDay;
      (this.$refs as any)['list-view'].openEdit('build', '新增', {
        recordType: maxDay > 60 ? overdueCollectType.getItem('2') : overdueCollectType.getItem('1'),
        riskType: []
      })
    },
    startPaymentProcess() {
      old.toPaymentProcess()
    },
    onCollapseChange(value: boolean) {
      this.collapse = value
    }
  }
})
</script>
